import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

const button = css``

export const classes = {
  button,
  root: css`
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border-radius: ${theme.spacing(2)}px;
    background: ${theme.go.schemes.colors.system.BgMain};
    padding: ${theme.spacing(1.5)}px;
    position: fixed;
    top: ${theme.spacing(2)}px;
    right: ${theme.spacing(2)}px;
    left: ${theme.spacing(2)}px;

    .${button} {
      height: ${theme.spacing(4)}px;
      padding-left: ${theme.spacing(1.5)}px;
      padding-right: ${theme.spacing(1.5)}px;
      border-radius: ${theme.spacing(1.25)}px;
    }
  `,
  postcardRoot: css`
    width: ${theme.spacing(3.75)}px;
    position: relative;
  `,
  postcard: css`
    width: ${theme.spacing(5.5)}px;
    height: ${theme.spacing(5.5)}px;
    padding: ${theme.spacing(0.25)}px;
    border-radius: ${theme.spacing(1)}px;
    transform: rotate(-9deg);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: -${theme.spacing(2)}px;
    bottom: -${theme.spacing(1.5)}px;
    background: ${theme.go.schemes.colors.system.BgMain};

    [dir='rtl'] & {
      left: auto;
      right: -${theme.spacing(2)}px;
    }
  `,
  imageRoot: css`
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: ${theme.spacing(0.75)}px;
  `,
  image: css`
    width: 100%;
    height: 100%;
    background: center / cover no-repeat;
  `,
}
